export default "__VITE_ASSET__BEZYFF9j__"